import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ConfigContabilidadCuentasPagoGuia;

export interface Props {
    value: Entity;
    label: string;
    error?: kea.FieldError;
    onChange: (value: Entity) => PromiseLike<void> | void;
}

/**
* Valida un Entity
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        AbonoAcuse: validation.required,
        AbonoEntregaDomicilio: validation.required,
        AbonoFlete: validation.required,
        AbonoIva: validation.required,
        AbonoRecoleccionDomicilio: validation.required,
        AbonoSeguroInterno: validation.required,
        AbonoSeguroExterno: validation.required,
        CargoRetencionIva: validation.required,
        CargoTotal: validation.required,
    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class CuentasPagoGuiaComponent extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Text = getField(kea.Text);

        return (
            <div>
                <kea.Panel title={this.props.label} error={this.props.error}>
                    {kea.autogrid(3, [
                        <Text field="AbonoFlete" label="Flete (abono)" />,
                        <Text field="AbonoRecoleccionDomicilio" label="Recolección a domicilio (abono)" />,
                        <Text field="AbonoEntregaDomicilio" label="Entrega a domicilio (abono)" />,
                        <Text field="AbonoSeguroInterno" label="Seguro interno (abono)" />,
                        <Text field="AbonoSeguroExterno" label="Seguro externo (abono)" />,
                        <Text field="AbonoAcuse" label="Acuse (abono)" />,
                        <Text field="AbonoIva" label="IVA (abono)" />,
                        <Text field="AbonoMovimientosManuales" label="Movimientos manuales (abono)" />,
                        <Text field="AbonoCobrosAdicionales" label="Cobros adicionales (abono)" />,
                        <Text field="CargoRetencionIva" label="Retención de IVA (cargo)" />,
                        <Text field="CargoTotal" label="Total (cargo)" />,
                        <Text field="CargoServiciosEspeciales" label="Servicios especiales (cargo)" />,

                        <Text field="ZonaExtendida" label="Zona Extendida" />,
                        <Text field="CargoAdministrativo" label="Cargo Administrativo" />,

                    ])}
                </kea.Panel>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/configuraciones/edit/components/contabilidad/pagoguias.tsx